const filesByTicketId = new Map<string, File[]>();
const EMPTY_FILES: File[] = [];

export const setStreamingTicketLocalFiles = (
  ticketId: string,
  files: File[],
): void => {
  if (files.length === 0) {
    filesByTicketId.delete(ticketId);
    return;
  }

  filesByTicketId.set(ticketId, files);
};

export const getStreamingTicketLocalFiles = (ticketId: string): File[] =>
  filesByTicketId.get(ticketId) ?? EMPTY_FILES;

export const clearStreamingTicketLocalFiles = (ticketId: string): void => {
  filesByTicketId.delete(ticketId);
};
